// extracted by mini-css-extract-plugin
export default {"bottom-row":"ListingBottomRow_bottom-row__FvMok","pagination-center":"ListingBottomRow_pagination-center__lwjSY"};